import { Avatar, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setUserId, toggleModal } from "../redux/userImagesSlice";

export default function UserAvatar({ userId, user, username, sx, clickable = true }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const displayName = username || t("user");
  const handleClick = async () => {
    await dispatch(setUserId(userId));
    dispatch(toggleModal());
  };
  return (
    <Button
      onClick={clickable ? (e) => {
        e.stopPropagation();
        if (user?.username && !user?.deletedAccount) handleClick();
      } : undefined}
      sx={sx || { p: 0, m: 0, mb: 1, minWidth: "unset" }}
    >
      <Avatar src={user?.profilePic?.url || null} alt={displayName} />
    </Button>
  );
}
